import { useMutation } from '@tanstack/react-query';

import CategoryApi from '../../../lib/api/category/CategoryApi';

/**
 * 카테고리 상품 리스트 삭제 응답 데이터 타입
 * @typedef categoryProductDeleteResponseDataType
 * @property {object} productCategoryLinks - 상품과 카테고리의 연결 된 매핑 정보
 * @property {number} productCategoryLinks.id - 상품과 카테고리의 연결 된 고유 ID
 * @property {number} productCategoryLinks.productId - 삭제된 카테고리 상품 ID
 * @property {number} productCategoryLinks.productCategoryId - 삭제된 상품과 연결된 카테고리 ID
 * @property {string} productCategoryLinks.createDate - 상품과 삭제 된 카테고리가 연결 된 매핑 일자
 */

/**
 * 카테고리 상품 리스트 삭제 mutate hook
 * @return {{deleteCategoryProduct: UseMutationResult<categoryProductDeleteResponseDataType, AxiosError, void, unknown>}}
 */
const useDeleteCategoryProduct = () => {
  const deleteCategoryProduct = useMutation({
    mutationFn: (data) => CategoryApi.deleteCategoryProduct(data),
  });

  return { deleteCategoryProduct };
};

export default useDeleteCategoryProduct;
